export default __webpack_public_path__ + "static/media/DAIF_Services_Screen1_in-end.394dbe42.jpg";